<template>
  <div class="widget position-relative">
    <BlockLoader :loading="loading" />
    <div class="widget-heading">
      <h2 class="textStyle">
        {{ title ? title : $t("absence.absences_not_justified") }}
      </h2>
    </div>
    <div class="widget-content">
      <div v-for="item in itemList" :key="item.id" class="item">
        <AbsenceAction :isStudeaManager="isStudeaManager" :item="item" @getJustifyForm="getJustifyForm" />
      </div>
      <div v-if="!itemList.length && type === 'event'">
        {{ $t("There are no events on this day.") }}
      </div>
    </div>
  </div>
</template>

<script>
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import AbsenceAction from "@/components/absence/AbsenceAction.vue";

export default {
  name: "AbsenceActionWidget",
  components: { AbsenceAction, BlockLoader },
  props: {
    itemList: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    isStudeaManager: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: "absence",
    },
  },
  emits: ["getJustifyForm"],
  methods: {
    getJustifyForm(item) {
      this.$emit("getJustifyForm", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.item + .item {
  margin-top: 10px;
}
</style>
